module.exports = __webpack_public_path__ + "static/TlwgTypewriter-Bold-ec8e1cb02cbcb12e63a0193fbc7c4257.woff2";